<template>
  <div id="app">
    <router-view class="content" />
  </div>
</template>

<script>
import { deleteCodeServerAPI, updateLogoutTime } from "@/api/auth";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      showRouterView: true,
    };
  },
  mounted() {
    let _beforeUnload_time = 0,
      _unload_time = 0;
    window.addEventListener("beforeunload", (event) => {
      _beforeUnload_time = new Date().getTime();
    });

    window.addEventListener("unload", (event) => {
      _unload_time = new Date().getTime();
      console.log(_unload_time - _beforeUnload_time);
      if (_unload_time - _beforeUnload_time <= 100) {
        deleteCodeServerAPI();
        updateLogoutTime();
      }
    });
    console.log("app mounted:", this.$store.state.user.token);
    if (this.$store.state.user.token && this.$store.state.user.token != "") {
      this.startLoginStatusEventSource({ router: this.$router });
    }
    // window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    // window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    ...mapActions({
      startLoginStatusEventSource: "eventSource/startLoginStatusEventSource",
    }),
    reload() {
      this.showRouterView = false;
      this.$nextTick(() => {
        this.showRouterView = true;
      });
    },

    // handleBeforeUnload(event) {
    //   // alert(1);
    //   const message = "你确定要离开此页面吗？";
    //   event.preventDefault(); // 某些浏览器需要调用 preventDefault
    //   event.returnValue = message; // 标准浏览器
    //   testAPI();
    //   return message; // 某些浏览器
    // },
  },
};
</script>
<style lang="scss">
@media (max-width: 1980px) {
  #app {
    transform: scale(0.64);
    width: 156.06vw; /* 1 / 0.64 = 1.5625 */
    height: 156.24vh; /* 1 / 0.64 = 1.5625 */
    /* transform: translate(-64%); */
    transform-origin: top left;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    // .sidebar-container {
    //   transform: scale(0.64);
    // }
    .edit-utli {
      transform: scale(1.5625);
      transform-origin: top left;
      left: -400px;
    }
  }
  #edit .el-dialog {
    transform: scale(1.5625); /* 恢复到正常大小 */
    transform-origin: top left;
    left: -400px;
  }
}
.el-dialog__wrapper {
  .el-dialog {
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    animation: fadeIn 0.3s ease;
    .el-dialog__header {
      border-bottom: 1px solid #f0f0f0;
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        // color: #333;
        color: #787171;
      }
    }
    .el-dialog__body {
      padding: 24px;
      color: #666;
      line-height: 1.8;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.core-project-create-dialog,
.core-project-save-dialog,
.soc-project-save-dialog,
.fault-project-create-dialog,
.soc-project-create-dialog {
  .el-form-item__content {
    display: flex;
    flex-grow: 1;
    .el-input {
      flex-grow: 1;
      margin-right: 20px;
    }
  }
}
</style>
